const LABEL_MUTED = 'data-label-muted';
const LABEL_UNMUTED = 'data-label-unmuted';

/**
 * @param {HTMLButtonElement} button
 * @param {HTMLVideoElement} video
 */
const updateVideoSoundToggle = (button, video) => {
  const isMuted = video.muted;
  const mutedIcon = button.querySelector('.video__sound-toggle-icon--muted');
  const unmutedIcon = button.querySelector('.video__sound-toggle-icon--unmuted');

  button.setAttribute('aria-pressed', String(!isMuted));
  button.setAttribute(
    'aria-label',
    isMuted ? button.getAttribute(LABEL_MUTED) || '' : button.getAttribute(LABEL_UNMUTED) || ''
  );

  mutedIcon?.classList.toggle('hidden', !isMuted);
  unmutedIcon?.classList.toggle('hidden', isMuted);
};

/**
 * @param {HTMLButtonElement} button
 * @param {HTMLVideoElement} video
 */
const toggleVideoSound = (button, video) => {
  if (video.muted) {
    video.muted = false;
    video.removeAttribute('muted');
    video.volume = 1;

    const playPromise = video.play();

    if (playPromise instanceof Promise) {
      playPromise.catch(() => {
        video.muted = true;
        video.setAttribute('muted', '');
        updateVideoSoundToggle(button, video);
      });
    }
  } else {
    video.muted = true;
    video.setAttribute('muted', '');
  }

  updateVideoSoundToggle(button, video);
};

/**
 * @param {ParentNode} root
 */
const initVideoSoundToggles = (root = document) => {
  const containers = root.querySelectorAll('[data-video-sound]');

  for (const container of containers) {
    if (!(container instanceof HTMLElement)) continue;
    if (container.dataset.videoSoundInitialized === 'true') continue;

    const video = container.querySelector('video');
    const button = container.querySelector('[data-video-sound-toggle]');

    if (!(video instanceof HTMLVideoElement) || !(button instanceof HTMLButtonElement)) continue;

    container.dataset.videoSoundInitialized = 'true';
    updateVideoSoundToggle(button, video);
  }
};

if (!window.__videoSoundToggleInitialized) {
  window.__videoSoundToggleInitialized = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-video-sound-toggle]');
    if (!(button instanceof HTMLButtonElement)) return;

    const container = button.closest('[data-video-sound]');
    const video = container?.querySelector('video');

    if (!(video instanceof HTMLVideoElement)) return;

    event.preventDefault();
    toggleVideoSound(button, video);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    initVideoSoundToggles(event.target);
  });
}

initVideoSoundToggles();
